"use strict";

exports.__esModule = true;
exports.PredefinedCommentsContext = void 0;
var _PredefinedCommentsController = require("./PredefinedCommentsController");
var _Utils = require("../../../Utils");
/**
 * Provides a configured PlantStateActivites to consumers.
 * @component
 */

var PredefinedCommentsContext = exports.PredefinedCommentsContext = (0, _Utils.createEnhancedContext)({
  propName: "predefinedComments",
  defaultController: _PredefinedCommentsController.PredefinedCommentsController
});